import Accordion from "@/components/Accordion/Accordion";
import {options, default as Vue} from "../base";

Vue.customElement('vue-accordion', Accordion, options)
